module.exports = __webpack_public_path__ + "static/media/website_on_phone.a032d9d7.jpg";